import { action } from 'typesafe-actions'
import { Video } from '@models/video-content'
import {RequestData} from "@models/axios";


export const enum VideoContentsActionTypes {
    FETCH_REQUEST = '@@videoContents/FETCH_REQUEST',
    FETCH_SUCCESS = '@@videoContents/FETCH_SUCCESS',
    FETCH_ERROR = '@@videoContents/FETCH_ERROR',

    DELETE_REQUEST = '@@videoContents/DELETE_REQUEST',
    DELETE_SUCCESS = '@@videoContents/DELETE_SUCCESS',
    DELETE_ERROR = '@@videoContents/DELETE_ERROR',

    CREATE_REQUEST = '@@videoContents/CREATE_REQUEST',
    CREATE_SUCCESS = '@@videoContents/CREATE_SUCCESS',
    CREATE_ERROR = '@@videoContents/CREATE_ERROR',

    UPDATE_REQUEST = '@@videoContents/UPDATE_REQUEST',
    UPDATE_SUCCESS = '@@videoContents/UPDATE_SUCCESS',
    UPDATE_ERROR = '@@videoContents/UPDATE_ERROR',

    FETCH_ITEM_REQUEST = '@@videoContents/FETCH_ITEM_REQUEST',
    FETCH_ITEM_SUCCESS = '@@videoContents/FETCH_ITEM_SUCCESS',
    FETCH_ITEM_ERROR = '@@videoContents/FETCH_ITEM_ERROR',
}


export const fetchRequest = (data:RequestData) => action(VideoContentsActionTypes.FETCH_REQUEST, data);
export const fetchSuccess = (data: Video[]) => action(VideoContentsActionTypes.FETCH_SUCCESS, data);
export const fetchError = (message: string) => action(VideoContentsActionTypes.FETCH_ERROR, message);

export const deleteRequest = (data:RequestData) => action(VideoContentsActionTypes.DELETE_REQUEST, data);
export const deleteSuccess = (data:any) => action(VideoContentsActionTypes.DELETE_SUCCESS, data);
export const deleteError = (message: string) => action(VideoContentsActionTypes.DELETE_ERROR, message);

export const createRequest = (data:RequestData) => action(VideoContentsActionTypes.CREATE_REQUEST, data);
export const createSuccess = (data: Video[]) => action(VideoContentsActionTypes.CREATE_SUCCESS, data);
export const createError = (message: string) => action(VideoContentsActionTypes.CREATE_ERROR, message);

export const updateRequest = (data:RequestData) => action(VideoContentsActionTypes.UPDATE_REQUEST, data);
export const updateSuccess = (data: Video[]) => action(VideoContentsActionTypes.UPDATE_SUCCESS, data);
export const updateError = (message: string) => action(VideoContentsActionTypes.UPDATE_ERROR, message);

export const fetchItemRequest = (data:RequestData) => action(VideoContentsActionTypes.FETCH_ITEM_REQUEST, data);
export const fetchItemSuccess = (data: Video[]) => action(VideoContentsActionTypes.FETCH_ITEM_SUCCESS, data);
export const fetchItemError = (message: string) => action(VideoContentsActionTypes.FETCH_ITEM_ERROR, message);